export default "__VITE_ASSET__6KKRoNGF__"